var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "material-specific-info-card" },
    [
      _c("tabs", {
        attrs: {
          tabs: _vm.tabs,
          "active-tab": _vm.activeTab,
          "tabs-styling": _vm.tabsStyling,
          "tabs-labels-styling": _vm.tabsLabelsStyling,
          "center-tabs": false
        },
        on: {
          startTabChange: function($event) {
            _vm.activeTab = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "details" &&
      _vm.currentFamilyFieldsComponent !== null &&
      _vm.materialSpecificFields
        ? _c(_vm.currentFamilyFieldsComponent, {
            tag: "component",
            style: {
              overflow: "auto",
              height: _vm.tabContentHeight
            },
            attrs: {
              "family-specific-fields": _vm.materialSpecificFields,
              installationTypeOptions: _vm.installationTypeOptions,
              lossValue: _vm.lossValue,
              editingData: _vm.editingData
            },
            on: {
              "update-object": function($event) {
                return _vm.$emit("update-material", $event)
              },
              "update-loss-value": function($event) {
                return _vm.$emit("update-loss-value", $event)
              },
              "update-required-field": function($event) {
                return _vm.$emit("update-required-field", $event)
              },
              updateFamilyIdSelect: function($event) {
                return _vm.$emit("update-family-id-select", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "accessories"
        ? _c(
            "div",
            {
              key: _vm.updateAccessoriesKey,
              style: { height: _vm.tabContentHeight }
            },
            [
              _c("Table", {
                attrs: {
                  checkbox: false,
                  loading: _vm.loading,
                  headers: _vm.accessoriesOthersHeaders,
                  items: _vm.accessories,
                  "add-row-button": _vm.editingData,
                  "action-buttons": _vm.editingData
                },
                on: {
                  input: function($event) {
                    return _vm.updateAccessories($event)
                  },
                  onScrollBottom: _vm.onScrollBottom,
                  onScrollTop: _vm.onScrollTop,
                  sortClick: _vm.onSortClick
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "others"
        ? _c(
            "div",
            { style: { height: _vm.tabContentHeight } },
            [
              _c("Table", {
                attrs: {
                  checkbox: false,
                  loading: _vm.loading,
                  headers: _vm.accessoriesOthersHeaders,
                  items: _vm.others,
                  "add-row-button": _vm.editingData,
                  "action-buttons": _vm.editingData
                },
                on: {
                  input: function($event) {
                    return _vm.updateOthers($event)
                  },
                  onScrollBottom: _vm.onScrollBottom,
                  onScrollTop: _vm.onScrollTop,
                  sortClick: _vm.onSortClick
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "custom_fields"
        ? _c("custom-fields-tab", {
            style: { overflow: "auto", height: _vm.tabContentHeight },
            attrs: {
              "editing-data": _vm.editingData,
              "custom-fields-inputs": _vm.customFieldsInputs,
              "custom-fields-values": _vm.customFieldsValues
            },
            on: {
              "update-object": function($event) {
                return _vm.$emit("update-custom-field", $event)
              },
              "update-required-field": function($event) {
                return _vm.$emit("update-required-field", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editingData
        ? _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Cancel"),
                  "button-color": "#FFF",
                  "label-color": "var(--app-primary-base)",
                  "button-styling": _vm.actionButtonsStyling
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$emit("cancel-edit")
                  }
                }
              }),
              _vm._v(" "),
              _c("custom-button", {
                attrs: {
                  label: _vm.$t(_vm.submitButtonLabel),
                  "button-color": "var(--app-primary-base)",
                  "label-color": "#FFF",
                  "button-styling": _vm.actionButtonsStylingSave,
                  disabled: !_vm.requiredFieldsFilled
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$emit("save-material")
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a20f68f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a20f68f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/StockManagement/MaterialSpecificInfo.vue
// module id = null
// module chunks = 